export const apiPath = '/v2/users';
const actionType = 'PEOPLE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
